import React from 'react';

import { DeleteIcon } from '@vlabs/icons';
import { Control } from '@vlabs/uikit';
import type { IconButtonProps } from '@vlabs/uikit/components/controls/button/icon-button';
import classNames from 'classnames';

import st from './DeleteCardsIconButton.module.sass';
import { useDeleteCardsWithConfirmationPoint3 } from './useDeleteCardsWithConfirmation.point3';
import type { CardId } from '@vlabs/api/artemy/model';
import { buildTestid } from '../../../shared/lib/utils';
import type { DeleteCardsProps } from '../types.point3';

const displayName = 'DeleteCardsIconButton';
const testid = buildTestid(displayName);

interface DeleteCardsIconButtonProps extends
  IconButtonProps,
  Omit<DeleteCardsProps, 'cardIds'> {
  flatOverride?: boolean;
  cardId: CardId;
}

function DeleteCardsIconButtonPoint3({
  cardId,
  className = undefined,
  flatOverride = false,
  variant = 'flat',
  shape = 'square',
  'data-testid': dataTestId = undefined,
  ...props
}: DeleteCardsIconButtonProps): React.JSX.Element {
  const deleteCardsHandler = useDeleteCardsWithConfirmationPoint3({ cardIds: [cardId] });
  return (
    <Control.IconButton
      className={classNames(className, {
        [st.FlatOverride as string]: flatOverride && variant === 'flat',
      })}
      data-testid={dataTestId}
      icon={<DeleteIcon />}
      kind="negative"
      shape={shape}
      size="small"
      variant={variant}
      {...testid(dataTestId)}
      {...props}
      onClick={deleteCardsHandler}
    />
  );
}

DeleteCardsIconButtonPoint3.displayName = displayName;

export { DeleteCardsIconButtonPoint3 };
